import { CizgiGrafik } from "./CizgiGrafik";
import type { GrafikOrtakProps, KucukCizgiNoktasi } from "./tipler";

export interface KucukCizgiProps extends GrafikOrtakProps {
  noktalar: readonly KucukCizgiNoktasi[];
}

export function KucukCizgi({ noktalar, ...ozellikler }: KucukCizgiProps) {
  return (
    <CizgiGrafik
      {...ozellikler}
      eksensiz
      seriler={[{ anahtar: "deger", etiket: ozellikler.baslik }]}
      noktalar={noktalar.map((nokta) => ({
        etiket: nokta.etiket,
        tarih: nokta.tarih,
        degerler: { deger: nokta.deger },
      }))}
    />
  );
}
